import React from 'react';
import { flowRight } from 'lodash';
import { I18nextProvider } from '@wix/wix-i18n-config';
import { initI18n } from '@wix/communities-blog-client-common';

import { connect } from '../../../common/components/runtime-context';
import ResponsiveListener from '../../../common/components/responsive-listener/responsive-listener';
import { getIsICUEnabled, getLanguage } from '../../../common/store/basic-params/basic-params-selectors';
import { getTranslations } from '../../../common/store/translations/translations-selectors';
import { withReduxStore } from '../../../common/components/runtime-context/with-redux-store';
import { getSectionUrl } from '../../../common/store/topology/topology-selectors';
import AppLoaded from '../../../common/components/app-loaded';
import Archive from '../archive';
import ArchiveNew from '../archive/archive-new';
import { getIsArchiveWidgetAdapterEnabled } from '../../aggregated-archive/selectors';
import styles from './app-root.scss';

class AppRoot extends React.Component {
  getI18nConfig = () => {
    const { language, translations, isICUEnabled } = this.props;

    if (this.lastLanguage !== language) {
      this.i18nConfig = initI18n(language, translations, isICUEnabled);
      this.lastLanguage = language;
    }
    return this.i18nConfig;
  };

  render() {
    if (this.props.isArchiveWidgetAdapterEnabled) {
      return (
        <ResponsiveListener>
          <div className={styles.baseStyles}>
            <ArchiveNew />
            <AppLoaded />
          </div>
        </ResponsiveListener>
      );
    }
    const i18n = this.getI18nConfig();

    return (
      <ResponsiveListener>
        <I18nextProvider i18n={i18n}>
          <div className={styles.baseStyles}>
            <Archive />
            <AppLoaded />
          </div>
        </I18nextProvider>
      </ResponsiveListener>
    );
  }
}

const mapRuntimeToProps = (state) => {
  return {
    language: getLanguage(state),
    translations: getTranslations(state),
    sectionUrl: getSectionUrl(state),
    isArchiveWidgetAdapterEnabled: getIsArchiveWidgetAdapterEnabled(state),
    isICUEnabled: getIsICUEnabled(state),
  };
};

export default flowRight(withReduxStore, connect(mapRuntimeToProps))(AppRoot);
